import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import DemoRoleRoute from './components/DemoRoleRoute';
import AuthPage from './pages/AuthPage';
import DemoPage from './pages/DemoPage';
import AdminPage from './pages/AdminPage';
import './App.css';

// Front door: redirects to /auth if not authenticated via AuthPage
function AuthGate({ children }) {
  // Already authenticated
  if (sessionStorage.getItem('vouch_auth') === 'authenticated') {
    return children;
  }
  // Redirect to /auth with returnTo so user lands back here after login
  const returnTo = window.location.pathname;
  return <Navigate to={returnTo !== '/' ? `/auth?returnTo=${encodeURIComponent(returnTo)}` : '/auth'} replace />;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Front door — only unprotected route */}
        <Route path="/auth" element={<AuthPage />} />

        {/* All routes below require AuthPage password */}
        <Route path="/demo" element={<AuthGate><DemoPage /></AuthGate>} />
        <Route path="/admin" element={<AuthGate><AdminPage /></AuthGate>} />
        <Route path="/candidate" element={<AuthGate><DemoRoleRoute role="candidate" email="tom@vouch-demo.com" password="vouch-demo-2024" /></AuthGate>} />
        <Route path="/voucher" element={<AuthGate><DemoRoleRoute role="voucher" email="tracey@vouch-demo.com" password="vouch-demo-2024" /></AuthGate>} />
        <Route path="/hiring-manager" element={<AuthGate><DemoRoleRoute role="hiring_manager" email="kevin@vouch-demo.com" password="vouch-demo-2024" /></AuthGate>} />

        {/* Root redirects to auth (the front door) */}
        <Route path="/" element={<Navigate to="/auth" replace />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
